import { FC, useEffect, useState } from "react";
import { useServices } from "../services/Services";
import { auth } from "./client";
import { useNavigate } from "react-router-dom";

const LinkedInCallback: FC<object> = () => {
  const services = useServices();
  const { data: user } = services.User.useGetCurrent();
  const [status, setStatus] = useState("Authorizing with LinkedIn...");
  const navigate = useNavigate();
  useEffect(() => {
    if (!user) {
      return;
    }
    services.User.linkedInAccessTokenFromCallback(
      user?.id,
      new URL(window.location.href),
      auth.getTokenOrUndefined()!,
    )
      .then(({ success: { returnUrl, postId } }) => {
        if (returnUrl) {
          navigate(returnUrl, { replace: true, state: { postId } });
        } else {
          navigate("/", { replace: true, state: { postId } });
        }
      })
      .catch((e: unknown) => {
        setStatus(`Error: ${(e as Error).message ?? e}`);
      });
  }, [user, services.User, navigate]);
  return <div>{status}</div>;
};

export default LinkedInCallback;
